import ConfigApp from "./config";
import { frontApiUrl } from "./apiendPoint";
import axios from "axios";

export const login = async (dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.LOGIN}`;

    const headers = {
      "Content-Type": "application/json",
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const emailNotification = async (dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.EMAIL_NOTIFICATION}`;
    const headers = {
      "Content-Type": "application/json",
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const verifyOtp = async (dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.VERIFY_OTP}`;
    const headers = {
      "Content-Type": "application/json",
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const resetPassword = async (dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.RESET_PASSWORD}`;
    const headers = {
      "Content-Type": "application/json",
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const userStatics = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.USER_STATICS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const recentUsers = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.RECENT_USERS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const partialUsers = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.PARTIAL_USERS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const userList = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.USER_LIST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getInterests = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.GET_INTERESTS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const editUser = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.EDIT_USER}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fileUpload = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.FILE_UPLOAD}`;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserDetails = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.GET_USER_DETAILS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteUser = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_USER}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const postList = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.POST_LIST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const particularPost = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.PARTICULAR_POST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteComment = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_COMMENT}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const editPost = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.EDIT_POST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deletePost = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_POST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const adsList = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.ADS_LIST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const viewAds = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.VIEW_ADS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const approveAds = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.APPROVE_ADS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const rejectAds = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.REJECT_ADS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteAds = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_ADS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getInterestslIST = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.GET_INTERESTS_LIST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .get(url, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const addInterests = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.ADD_INTERESTS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const editInterests = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.EDIT_INTERESTS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteInterests = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_INTERESTS}`;
    const headers = {
      "Content-Type": "application/json",

      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const contactUsList = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.CONTACT_US_LIST}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .get(url, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteContactUs = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_CONTACT_US}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getTermsConditions = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.GET_TERMS_CONDITIONS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .get(url, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const editTermsConditions = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.EDIT_TERMS_CONDITIONS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateProfile = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.UPDATE_PROFILE}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updatePassword = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.UPDATE_PASSWORD}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const flagsReports = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.FLAGS_REPORTS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios

      .get(url, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteFlagsReports = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_FLAGS_REPORTS}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const allCommentsReplies = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.ALL_COMMENTS_REPLIES}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteCommentReplies = async (token, dict) => {
  try {
    const url = `${ConfigApp.URL}${frontApiUrl.DELETE_COMMENT_REPLIES}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = await axios
      .post(url, dict, { headers })
      .then((response) => {
        const res = response.data;
        return res;
      })
      .catch((error) => {});

    return data;
  } catch (error) {
    console.log(error);
  }
};
